import React from 'react';

/**
 * VibeSprint logo.
 * - Mark: 3 ascending rounded bars in purple → gradient → orange.
 *   Represents the 3 lanes (Build / Fix / Ignore) + sprint-momentum.
 * - Wordmark: "VibeSprint" in bold with gradient V.
 *
 * Props:
 *   size: 'sm' | 'md' | 'lg'
 *   variant: 'full' (mark + wordmark) | 'mark' (just the icon)
 *   className: extra classes
 */
const Logo = ({ size = 'md', variant = 'full', className = '' }) => {
  const sizeMap = {
    sm: { mark: 20, text: 'text-base', gap: 'gap-1.5' },
    md: { mark: 26, text: 'text-xl', gap: 'gap-2' },
    lg: { mark: 34, text: 'text-2xl', gap: 'gap-2.5' },
  };
  const cfg = sizeMap[size] || sizeMap.md;

  const Mark = (
    <svg
      width={cfg.mark}
      height={cfg.mark}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      className="flex-shrink-0"
    >
      <defs>
        <linearGradient id="vs-bar-mid" x1="0%" y1="100%" x2="0%" y2="0%">
          <stop offset="0%" stopColor="#8B5CF6" />
          <stop offset="100%" stopColor="#F97316" />
        </linearGradient>
        <linearGradient id="vs-orange" x1="0%" y1="100%" x2="0%" y2="0%">
          <stop offset="0%" stopColor="#FB923C" />
          <stop offset="100%" stopColor="#F97316" />
        </linearGradient>
      </defs>
      {/* Bar 1: purple, shortest (Ignore) */}
      <rect x="3" y="18" width="6" height="11" rx="1.5" fill="#8B5CF6" />
      {/* Bar 2: gradient, medium (Fix) */}
      <rect x="13" y="11" width="6" height="18" rx="1.5" fill="url(#vs-bar-mid)" />
      {/* Bar 3: orange, tallest (Build Next) */}
      <rect x="23" y="4" width="6" height="25" rx="1.5" fill="url(#vs-orange)" />
      {/* Sparkle accent on top of tallest bar */}
      <circle cx="26" cy="2.5" r="1.4" fill="#F97316" opacity="0.9" />
    </svg>
  );

  if (variant === 'mark') {
    return <span className={className}>{Mark}</span>;
  }

  return (
    <span className={`inline-flex items-center ${cfg.gap} ${className}`} data-testid="vibesprint-logo">
      {Mark}
      <span
        className={`font-bold tracking-tight ${cfg.text} bg-clip-text text-transparent bg-gradient-to-r from-[#8B5CF6] via-[#8B5CF6] to-[#F97316]`}
      >
        VibeSprint
      </span>
    </span>
  );
};

export default Logo;
